var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 44,
    viewBox: "0 0 35 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2579 17.602C34.192 20.379 33.5157 23.1075 32.2769 25.5939C29.4799 31.709 25.385 37.1418 20.2769 41.5149C19.7178 41.9598 19.1231 42.3582 18.4989 42.706C18.1814 42.9234 17.8083 43.0455 17.4236 43.0579C17.039 43.0703 16.6588 42.9725 16.3279 42.7759C15.2332 42.1753 14.1956 41.4761 13.2279 40.6869C7.77984 35.9419 3.58487 29.9277 1.01391 23.1759C-2.53909 13.5969 3.7009 2.14094 14.5819 0.284944C18.145 -0.267035 21.7912 0.341907 24.9815 2.02188C28.1718 3.70186 30.737 6.3637 32.2979 9.61392C33.5478 12.0937 34.2176 14.8253 34.2569 17.602H34.2579ZM8.58691 11.3759C7.26968 13.1839 6.62391 15.3946 6.7608 17.6274C6.89769 19.8601 7.80867 21.9754 9.33691 23.6089C11.1226 25.4873 13.5234 26.6619 16.1023 26.9189C18.6813 27.1758 21.2667 26.498 23.3879 25.0089C25.2435 23.6239 26.5653 21.6418 27.1306 19.3964C27.6959 17.151 27.4704 14.7794 26.4918 12.6808C25.5133 10.5823 23.8415 8.88497 21.758 7.87467C19.6746 6.86436 17.3067 6.60277 15.0529 7.13394C16.7529 8.78394 17.2089 10.321 16.5129 12.002C16.1878 12.7682 15.6406 13.4195 14.9419 13.8719C14.2433 14.3242 13.4251 14.5569 12.5929 14.5399C11.6726 14.5182 10.7844 14.198 10.062 13.6275C9.33962 13.057 8.82225 12.2671 8.58788 11.377L8.58691 11.3759Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationN);
export default __webpack_public_path__ + "static/media/location-n.325a0bbff988dbc475e1afc601a83253.svg";
export { ForwardRef as ReactComponent };